"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var asyncPromise = null;
var getAegis = function () {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (asyncPromise) {
        return asyncPromise;
    }
    asyncPromise = Promise.resolve().then(function () { return tslib_1.__importStar(require('@tencent/aegis-web-sdk')); });
    return asyncPromise;
};
var EnumLoadingState;
(function (EnumLoadingState) {
    EnumLoadingState[EnumLoadingState["ready"] = 0] = "ready";
    EnumLoadingState[EnumLoadingState["pending"] = 1] = "pending";
    EnumLoadingState[EnumLoadingState["fulfilled"] = 2] = "fulfilled";
    EnumLoadingState[EnumLoadingState["rejected"] = 3] = "rejected";
})(EnumLoadingState || (EnumLoadingState = {}));
var aegis = null;
var loadState = EnumLoadingState.ready;
// 上报缓存
var cacheList = {
    logAll: [],
    error: [],
    report: [],
};
var beforeReport = function (log) {
    var level = Number(log.level);
    if (level > 2) {
        // 忽略大量的灯塔上报错误
        var ignores = [
            /otheve\.beacon\.qq\.com/,
            /h\.trace\.qq\.com/,
            /stats\.g\.doubleclick\.net/,
            /www\.google-analytics\.com/,
        ];
        if (ignores.some(function (re) { return re.test(log.msg); })) {
            return false;
        }
    }
};
function initAegis() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var Aegis, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(loadState === EnumLoadingState.ready)) return [3 /*break*/, 6];
                    loadState = EnumLoadingState.pending;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    Aegis = window.Aegis;
                    if (!!Aegis) return [3 /*break*/, 3];
                    return [4 /*yield*/, getAegis()];
                case 2:
                    Aegis = (_a.sent()).default;
                    _a.label = 3;
                case 3:
                    loadState = EnumLoadingState.fulfilled;
                    aegis = new Aegis({
                        id: 'Jj99lSlJxo43k646vg',
                        reportApiSpeed: false,
                        reportAssetSpeed: true,
                    });
                    aegis.setConfig({
                        beforeReport: beforeReport,
                    });
                    return [2 /*return*/, aegis];
                case 4:
                    err_1 = _a.sent();
                    loadState = EnumLoadingState.rejected;
                    throw err_1;
                case 5: return [3 /*break*/, 7];
                case 6: throw loadState;
                case 7: return [2 /*return*/];
            }
        });
    });
}
// eslint-disable-next-line @typescript-eslint/naming-convention
var metAegis = {
    logAll: function () {
        var props = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            props[_i] = arguments[_i];
        }
        if (web_base_1.isServer) {
            cacheList.logAll.push(props);
            return;
        }
        if (window.__DISABLE_AEGIS) {
            return;
        }
        if (aegis) {
            aegis.infoAll.apply(aegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
        }
        else {
            initAegis()
                .then(function (asyncAegis) {
                cacheList.logAll.forEach(function (item) {
                    asyncAegis.infoAll.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(item), false));
                });
                cacheList.logAll = [];
                asyncAegis.infoAll.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
            })
                .catch(function () {
                cacheList.logAll.push(props);
            });
        }
    },
    error: function () {
        var props = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            props[_i] = arguments[_i];
        }
        if (web_base_1.isServer) {
            cacheList.error.push(props);
            return;
        }
        if (window.__DISABLE_AEGIS) {
            return;
        }
        if (aegis) {
            aegis.error.apply(aegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
        }
        else {
            initAegis()
                .then(function (asyncAegis) {
                cacheList.error.forEach(function (item) {
                    asyncAegis.error.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(item), false));
                });
                cacheList.error = [];
                asyncAegis.error.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
            })
                .catch(function () {
                cacheList.error.push(props);
            });
        }
    },
    report: function () {
        var props = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            props[_i] = arguments[_i];
        }
        if (web_base_1.isServer) {
            cacheList.report.push(props);
            return;
        }
        if (window.__DISABLE_AEGIS) {
            return;
        }
        if (aegis) {
            aegis.report.apply(aegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
        }
        else {
            initAegis()
                .then(function (asyncAegis) {
                cacheList.report.forEach(function (item) {
                    asyncAegis.report.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(item), false));
                });
                cacheList.report = [];
                asyncAegis.report.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
            })
                .catch(function () {
                cacheList.report.push(props);
            });
        }
    },
    setConfig: function () {
        var props = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            props[_i] = arguments[_i];
        }
        if (!web_base_1.isServer && window.__DISABLE_AEGIS) {
            return;
        }
        if (aegis) {
            aegis.setConfig.apply(aegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
        }
        else {
            initAegis()
                .then(function (asyncAegis) {
                asyncAegis.setConfig.apply(asyncAegis, tslib_1.__spreadArray([], tslib_1.__read(props), false));
            })
                .catch(function (err) {
                console.log('setConfig:', err);
            });
        }
    },
};
exports.default = metAegis;
//# sourceMappingURL=init-aegis.js.map